import { ReactElement, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { LoadingButton } from '@mui/lab'
import { Stack, Typography } from '@mui/material'
import { SwitchLabeled } from '@ui/actions'
import { CoordinatePointInput } from '@ui/forms'
import { SplitElementIcon } from '@ui/icons'

interface Props {
  isLoading: boolean
  interactionMode: '2D' | '3D'
}

const SplitLineElementFormFields = ({ isLoading, interactionMode }: Props): ReactElement => {
  const { setValue } = useFormContext()
  const [limitXYDecimals, setLimitXYDecimals] = useState(true)
  const [limitZDecimals, setLimitZDecimals] = useState(false)
  const pointManipulation = useMemo(
    () => ({
      x: { roundOnReplace: limitXYDecimals },
      y: { roundOnReplace: limitXYDecimals },
      z: { roundOnReplace: limitZDecimals },
    }),
    [limitXYDecimals, limitZDecimals],
  )

  const handleReplace = (x: number, y: number, z: number) => {
    setValue('splitPoint.x', x)
    setValue('splitPoint.y', y)
    if (interactionMode !== '2D') {
      setValue('splitPoint.z', z)
    }
  }

  return (
    <Stack spacing={1} alignContent="center" direction="row">
      <CoordinatePointInput
        label="Teilungspunkt"
        name="splitPoint"
        pointManipulation={pointManipulation}
        onReplace={handleReplace}
        actions={
          <Stack direction="row" spacing={0.5} alignItems="center">
            <Typography>Auf 2 Dez. begrenzen:</Typography>
            <SwitchLabeled
              checked={limitXYDecimals}
              onChange={event => {
                setLimitXYDecimals(event.target.checked)
              }}
              label="XY"
              sx={{ padding: 0 }}
            />
            <SwitchLabeled
              checked={limitZDecimals}
              onChange={event => {
                setLimitZDecimals(event.target.checked)
              }}
              label="Z"
              sx={{ padding: 0 }}
            />
          </Stack>
        }
      />
      <LoadingButton
        type="submit"
        variant="contained"
        color="primary"
        size="small"
        loading={isLoading}
      >
        <SplitElementIcon />
      </LoadingButton>
    </Stack>
  )
}

export default SplitLineElementFormFields
